import { render, staticRenderFns } from "./deviceRelation.vue?vue&type=template&id=989b3352&scoped=true&"
import script from "./deviceRelation.vue?vue&type=script&lang=js&"
export * from "./deviceRelation.vue?vue&type=script&lang=js&"
import style0 from "./deviceRelation.vue?vue&type=style&index=0&id=989b3352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989b3352",
  null
  
)

export default component.exports